import Axios from "@/plugins/Axios";

export class BoletosService {
  async verificarBoleto(prestacaoId) {
    const response = await Axios().get(`boletos/boleto-incluir/${prestacaoId}`);
    return response.data;
  }
}

export default new BoletosService();
